import { Resolver } from "react-hook-form";
import { baseFormSchema } from "../Interface/baseFormSchema";
import { taskFormSchema } from "../Interface/taskFormSchema";
import { FormDataType } from "../TaskForm";

// A custom resolver function to handle different schemas (ie the task and assignement)
export function CustomResolver(assignment: boolean): Resolver<FormDataType> {
	const customResolver: Resolver<FormDataType> = async (values) => {
		// Choose the correct schema based on assignment state
		const schema = assignment ? baseFormSchema : taskFormSchema;

		// Use zodResolver with the chosen schema
		try {
			// Run schema validation
			const result = await schema.safeParseAsync(values);

			if (result.success) {
				return {
					values,
					errors: {},
				};
			} else {
				// Convert zod errors to react-hook-form errors
				const errors = {};
				result.error.errors.forEach((error) => {
					const path = error.path.join(".");
					// @ts-ignore - Dynamic property assignment
					errors[path] = {
						type: "validation",
						message: error.message,
					};
				});

				return {
					values: {},
					errors,
				};
			}
		} catch (e) {
			return {
				values: {},
				errors: {
					root: {
						type: "validation",
						message: e instanceof Error ? e.message : "Form validation failed",
					},
				},
			};
		}
	};

	return customResolver;
}
